module.exports = __webpack_public_path__ + "static/media/cliente-cooper-batata.e6c33752.webp";